import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import Seo from "../components/Seo";

export const Login = () => {
  const { login, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.name}`);
      if (u.role === "admin") nav("/admin");
      else if (u.role === "vip") nav("/vip");
      else nav("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="pt-32 max-w-md mx-auto px-6 pb-32">
      <Seo title="Sign In" description="Access your OPIKJEWELS Maison account." path="/login" noIndex />
      <p className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5">Maison Account</p>
      <h1 className="font-heading font-light text-5xl mb-8">Sign in.</h1>
      <form onSubmit={submit} className="space-y-6">
        <input data-testid="login-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
        <input data-testid="login-password" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
        <button data-testid="login-submit" disabled={busy} className="w-full bg-gold text-black font-accent uppercase tracking-[0.28em] text-xs py-4 hover:bg-ivory transition-colors duration-500 disabled:opacity-50">{busy ? "Signing in…" : "Sign In"}</button>
      </form>
      <div className="mt-6 text-white/50 text-sm">No account? <Link to="/register" className="text-gold hover:text-ivory">Register</Link></div>
    </div>
  );
};

export const Register = () => {
  const { register, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Welcome to OPIKJEWELS.");
      nav("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="register-page" className="pt-32 max-w-md mx-auto px-6 pb-32">
      <p className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5">Create Account</p>
      <h1 className="font-heading font-light text-5xl mb-8">Join the Maison.</h1>
      <form onSubmit={submit} className="space-y-6">
        <input data-testid="register-name" required placeholder="Full Name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
        <input data-testid="register-email" required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
        <input data-testid="register-password" required type="password" minLength={6} placeholder="Password (min 6)" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
        <button data-testid="register-submit" disabled={busy} className="w-full bg-gold text-black font-accent uppercase tracking-[0.28em] text-xs py-4 hover:bg-ivory disabled:opacity-50">{busy ? "Creating…" : "Create Account"}</button>
      </form>
      <div className="mt-6 text-white/50 text-sm">Have an account? <Link to="/login" className="text-gold hover:text-ivory">Sign in</Link></div>
    </div>
  );
};
